import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  TextField,
  InputAdornment
} from '@mui/material';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const DownloadDialog = ({ open, onClose, downloadUrl, fileName }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(downloadUrl);
  };

  const handleDownload = () => {
    window.open(downloadUrl, '_blank');
  };

  return (
    <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
            sx: {
              borderRadius: 3 
            }
          }}
        >
      <DialogTitle
        sx={{
          backgroundColor: '#d1e8e2',
          color: 'black',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: 'bold'
        }}
      >
        Your file is ready for download.
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ backgroundColor: '#f5f5f5' }}>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Copy the below link and paste it in the browser to download. This link will be active only for 24 hrs.
        </Typography>

        <TextField
          fullWidth
          value={downloadUrl}
          variant="outlined"
          size="small"
          readOnly
          slots={{
            endAdornment: InputAdornment
          }}
          slotProps={{
            endAdornment: {
              position: 'end',
              children: (
                <IconButton onClick={handleCopy}>
                  <ContentCopyIcon />
                </IconButton>
              )
            }
          }}
        />
      </DialogContent>

      <DialogActions sx={{ backgroundColor: '#f5f5f5', justifyContent: 'center', }}>
        <Button
          variant="contained"
          startIcon={<CloudDownloadIcon />}
          onClick={handleDownload}
          sx={{
            backgroundColor: '#d1e8e2', // pastel green
            color: 'black',
            '&:hover': {
              backgroundColor: '#c8e6c9' // slightly darker on hover
            }
          }}
        >
          Download Now
        </Button>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadDialog;